<template>
  <a-modal
    v-model:visible="visible"
    :maskClosable="false"
    :footer="null"
    :width="1100"
  >
    <h2>About Us</h2>
    <div class="content">
    </div>
  </a-modal>
</template>

<script>
import { ref } from "vue";
export default {
    name:"AboutUs",
    setup() {
        const visible = ref(false);
        const showModal = () => {
          visible.value = true;
        }
        return {
            visible,
            showModal
        }
    }
};
</script>

<style lang="less" scoped>
.content {
  height: 500px;
  overflow: auto;
  //   margin-top: 20px;
}
.bold {
  font-weight: 700;
}
p {
  line-height: 2;
}
</style>